<div class="menu-indice"><a routerLink="../../../../../gestionparticipantefirma/{{a_tipo}}/{{c_constancia}}">Volver a Listado de {{x_tipo}}</a> / {{x_titulo}} </div>

<br>
  <div class="row">
    <div class="col-md-6" *ngIf="mostrar_mensaje_carga">
      <mdb-card class="text-white mb-3">
        <mdb-card-header style="background-color: #2691a6;">
          {{titulo_mensaje}}
        </mdb-card-header>
        <mdb-card-body style="background-color: #91b8d0;">
            <div class=" align-items-center">
              <div class="form-group col-md-12">
                {{mensaje}}
              </div>
              <div class="form-group col-md-12" *ngIf="listParticipantes.length>0">
                Ejecutados {{recibidos}} de {{listParticipantes.length}}. Correctos {{correctos}}/{{listParticipantes.length}}
              </div>
              <br>
              <div class="justify-content-center" style="text-align: center;">
                <button mdbBtn type="button" routerLink="../../../../../gestionparticipantefirma/{{a_tipo}}/{{c_constancia}}"  size="md" class="btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="arrow-left" class="mr-2"></mdb-icon>REGRESAR A LISTADO</button>
              </div>
            </div>
        </mdb-card-body>
      </mdb-card>
    </div>
    <div class="col-md-6" *ngIf="mostrar_mensaje_error">
      <mdb-card class="text-white mb-3">
        <mdb-card-header style="background-color: #b63838;">
          {{titulo_mensaje}}
        </mdb-card-header>
        <mdb-card-body style="background-color: #d09b9b;">
          <div class=" align-items-center">
              <div class="form-group col-md-12">
                {{mensaje}}
            </div>
            <br>
            <div class="justify-content-center" style="text-align: center;">
              <button mdbBtn type="button" routerLink="../../../../../gestionparticipantefirma/{{a_tipo}}/{{c_constancia}}"  size="md" class="btn btn-blue btn-rounded" mdbWavesEffect>
                  <mdb-icon fas icon="arrow-left" class="mr-2"></mdb-icon>REGRESAR A LISTADO</button>
            </div>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
    <div class="col-md-6" *ngIf="mostrar_mensaje_ok">
      <mdb-card>
        <mdb-card-header style="background-color: #8BC34A;">
          {{titulo_mensaje}}
        </mdb-card-header>
        <mdb-card-body style="background-color: #DCEDC8;">
          <div class=" align-items-center">

              <div class="form-group col-md-12">
                {{mensaje}}
            </div>
              <br>
              <div class="justify-content-center" style="text-align: center;">
                <button mdbBtn type="button" routerLink="../../../../../gestionparticipantefirma/{{a_tipo}}/{{c_constancia}}"  size="md" class="btn btn-blue btn-rounded" mdbWavesEffect>
                    <mdb-icon fas icon="arrow-left" class="mr-2"></mdb-icon>REGRESAR A LISTADO</button>

              <button mdbBtn type="button" *ngIf="mostrar_boton_ver" routerLink="../../../../../firmado/f/{{c_participante}}"  size="md" class="btn btn-teal btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="eye" class="mr-2"></mdb-icon>VER CONSTANCIA FIRMADA</button>
            </div>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>
    <br/>
    <mdb-card *ngIf="mostrarParticipantesError">
      <div class="table-responsive">
      <table mdbTable hover="true" class="table">
          <thead>
            <tr>
              <th *ngFor="let head of headElements" scope="col">{{head}}</th>
            </tr>
          </thead>
          <tbody>
            <tr mdbTableCol *ngFor="let listParti of listParticipantesMostrar | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
              <th>{{i + 1+ (page-1)*10}}</th>
              <th>{{listParti.x_nombres}}</th>
              <td *ngIf="listParti.x_actualizado=='0'">Actualizando...</td>
              <td *ngIf="listParti.x_actualizado=='1'">Correcto</td>
              <td *ngIf="listParti.x_actualizado=='-1'">
                <button color="blue" (click)="onActualizarUnitario(listParti)" type="button" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn>
                  <mdb-icon fas icon="copy" size="lg"></mdb-icon>Actualizar</button>
              </td>
            </tr>
          </tbody>
        </table>

        </div>
          <div class="text-center" *ngIf="listParticipantesMostrar.length>10">

            <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
              [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listParticipantesMostrar.length">
            </ngb-pagination>

          </div>

    </mdb-card>

<br>
